import React, { useState, useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { intersectionObserver } from 'utilities/dom'
import { DefaultContainer, ListContainer } from './s'
import Loader from 'components/loader'
import { Ghost } from 'components/button'

const LoadMore = ({ useItems, auto: initialAuto = false, container: Container, appearance }) => {
    const {
        enabled,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage
    } = useItems()

    const [auto, setAuto] = useState(initialAuto)

    const onIntersect = useCallback(() => {
        if(!enabled || !hasNextPage || !auto) {
            return
        }

        fetchNextPage()
    }, [enabled, hasNextPage, auto, fetchNextPage])

    const [intersecter, setIntersecter] = useState(intersectionObserver(onIntersect))

    useEffect(() => {
        setIntersecter(intersectionObserver(onIntersect))
    }, [onIntersect])

    useEffect(() => () => intersecter?.destroy?.(), [])

    if(!enabled || !hasNextPage) {
        return null
    }

    Container ??= ((appearance === 'list') ?
        ListContainer :
        DefaultContainer
    )

    return (
        <Container ref={intersecter?.ref}>
            {(!isFetchingNextPage && !auto) && (
                <Ghost
                    className="constructive"
                    onClick={() => {
                        setAuto(true)
                        fetchNextPage()
                    }}>
                    <FormattedMessage
                        id="action_load_more"
                        defaultMessage="Load more…"
                    />
                </Ghost>
            )}
            {!!isFetchingNextPage && <Loader />}
        </Container>
    )
}

export default LoadMore